export default "__VITE_ASSET__BCZFl0Zg__"